export default __webpack_public_path__ + "10073092ff18edae91b267b8a0745ec0.webp";